<div class="container-fluid" style="padding:0">
    <div class="row">
        <div class="col-lg-2">
            <app-navbar></app-navbar>
        </div>
        <div class="col-lg-8">
            <br>
            <h4 class="modal-title" id="modal-basic-title">Actualizar Datos Generales Grupo</h4>
            <br>
            <div class="row">
                <div class="col-3">
                    <button class="btn btn-secondary fondoAmarillo" style="width: 100%;" id="generales" (click)="changeSeccion(1)">Generales</button>
                </div>

                <div class="col-3">
                    <button class="btn btn-secondary" style="width: 100%;" id="fotografia" (click)="changeSeccion(2)">Fotografía</button>
                </div>

                <div class="col-3">
                    <button class="btn btn-secondary" style="width: 100%;" id="fiestas" (click)="changeSeccion(3)">Fiestas y Viajes</button>
                </div>

                <div class="col-3">
                    <button class="btn btn-secondary" style="width: 100%;" id="configuracion" (click)="changeSeccion(4)">Configuración</button>
                </div>
            </div>
            <br>

            <div *ngIf="seccion == 1">
                <span class="bold">Nombre del Grupo</span>
                <input type="text" class="form-control" placeholder="Nombre" [(ngModel)]="formularioEdit.nombre_grupo"><br>
    
                <span class="bold">Número de Personas</span>
                <input type="text" class="form-control" placeholder="Número de Personas" [(ngModel)]="formularioEdit.numero_personas"><br>

                <span class="bold">Escuela</span>
                <select #institucionEditSelect class="form-control" [(ngModel)]="formularioEdit.institucion">
                <option value="" class="form-control">Seleccione Escuela</option>
                <option *ngFor = "let institucion of instituciones" [value]="institucion.id" [attr.selected]="institucion.id==institucionSelected ? true : null">{{institucion.nombre}}</option>
                </select>
                <br><br>

                <span class="bold">Carrera</span>
                <select #carreraEditSelect class="form-control" [(ngModel)]="formularioEdit.carrera">
                    <option value="" class="form-control">Seleccione Carrera</option>
                    <option *ngFor = "let carrera of carreras" [value]="carrera.id" [attr.selected]="carrera.id==carreraSelected ? true : null">{{carrera.nombre}}</option>
                </select>
                <br><br>

                <span class="bold">Categorías</span>
                <div class="col-3" *ngFor="let categoria of categorias">
                    <input type="checkbox" (click)="seleccionarCategoria(categoria.id, $event);" [checked]="categoria.checked"  id="checkbox{{categoria.id}}">
                    {{categoria.nombre}}
                </div><br>

                

                <span class="bold">Forma de Pago</span><br>
                <select #formaPagoGrupo [(ngModel)]="formularioEdit.forma_pago" class="form-control">
                <option value="0" >Seleccione Forma de Pago</option>
                <option value="1" >Plan 1 50/50</option>
                <option value="2">Plan 2 30/30/40</option>
                </select><br>


                <div *ngIf="formularioEdit.forma_pago != 0">
                    <span class="bold">Fecha Pago Uno</span>
                    <div class="input-group">
                        <input id="fecha_pago_1" class="form-control"  [(ngModel)]="formularioEdit.fecha_pago_uno" placeholder="Fecha de pago 1 yyyy-mm-dd" name="dp1b" ngbDatepicker #dp1b="ngbDatepicker">
                        <div class="input-group-append">
                        <button class="btn btn-outline-secondary calendar" (click)="dp1b.toggle()" type="button">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-calendar-date" viewBox="0 0 16 16">
                            <path d="M6.445 11.688V6.354h-.633A12.6 12.6 0 0 0 4.5 7.16v.695c.375-.257.969-.62 1.258-.777h.012v4.61h.675zm1.188-1.305c.047.64.594 1.406 1.703 1.406 1.258 0 2-1.066 2-2.871 0-1.934-.781-2.668-1.953-2.668-.926 0-1.797.672-1.797 1.809 0 1.16.824 1.77 1.676 1.77.746 0 1.23-.376 1.383-.79h.027c-.004 1.316-.461 2.164-1.305 2.164-.664 0-1.008-.45-1.05-.82h-.684zm2.953-2.317c0 .696-.559 1.18-1.184 1.18-.601 0-1.144-.383-1.144-1.2 0-.823.582-1.21 1.168-1.21.633 0 1.16.398 1.16 1.23z"/>
                            <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
                            </svg>
                        </button>
                        </div>
                    </div>
                    <br>
                    
                    <span class="bold">Fecha Pago Dos</span>
                    <div class="input-group">
                        <input id="fecha_pago_2" class="form-control" placeholder="Fecha de pago 2 yyyy-mm-dd" [(ngModel)]="formularioEdit.fecha_pago_dos" name="dp2b" ngbDatepicker #dp2b="ngbDatepicker">
                        <div class="input-group-append">
                        <button class="btn btn-outline-secondary calendar" (click)="dp2b.toggle()" type="button">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-calendar-date" viewBox="0 0 16 16">
                            <path d="M6.445 11.688V6.354h-.633A12.6 12.6 0 0 0 4.5 7.16v.695c.375-.257.969-.62 1.258-.777h.012v4.61h.675zm1.188-1.305c.047.64.594 1.406 1.703 1.406 1.258 0 2-1.066 2-2.871 0-1.934-.781-2.668-1.953-2.668-.926 0-1.797.672-1.797 1.809 0 1.16.824 1.77 1.676 1.77.746 0 1.23-.376 1.383-.79h.027c-.004 1.316-.461 2.164-1.305 2.164-.664 0-1.008-.45-1.05-.82h-.684zm2.953-2.317c0 .696-.559 1.18-1.184 1.18-.601 0-1.144-.383-1.144-1.2 0-.823.582-1.21 1.168-1.21.633 0 1.16.398 1.16 1.23z"/>
                            <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
                            </svg>
                        </button>
                        </div>
                    </div>
                <br>
                </div>  
                
                <div *ngIf="formularioEdit.forma_pago == 2">
                    <span class="bold">Fecha Pago Tres</span>
                    <div class="input-group">
                        <input id="fecha_pago_3" class="form-control" placeholder="Fecha de pago 3 yyyy-mm-dd" [(ngModel)]="formularioEdit.fecha_pago_tres" value="formularioEdit.fecha_pago_tres" name="dp3b" ngbDatepicker #dp3b="ngbDatepicker">
                        <div class="input-group-append">
                        <button class="btn btn-outline-secondary calendar" (click)="dp3b.toggle()" type="button">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-calendar-date" viewBox="0 0 16 16">
                            <path d="M6.445 11.688V6.354h-.633A12.6 12.6 0 0 0 4.5 7.16v.695c.375-.257.969-.62 1.258-.777h.012v4.61h.675zm1.188-1.305c.047.64.594 1.406 1.703 1.406 1.258 0 2-1.066 2-2.871 0-1.934-.781-2.668-1.953-2.668-.926 0-1.797.672-1.797 1.809 0 1.16.824 1.77 1.676 1.77.746 0 1.23-.376 1.383-.79h.027c-.004 1.316-.461 2.164-1.305 2.164-.664 0-1.008-.45-1.05-.82h-.684zm2.953-2.317c0 .696-.559 1.18-1.184 1.18-.601 0-1.144-.383-1.144-1.2 0-.823.582-1.21 1.168-1.21.633 0 1.16.398 1.16 1.23z"/>
                            <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
                            </svg>
                        </button>
                        </div>
                    </div>
                    <br>
                </div>
    
                <span class="bold">Fecha de Graduación</span>
                <div class="input-group">
                    <input id="fecha_pago_3" class="form-control" placeholder="Fecha de graduación" [(ngModel)]="formularioEdit.fecha_graduacion" value="formularioEdit.fecha_graduacion" name="dp4b" ngbDatepicker #dp4b="ngbDatepicker">
                    <div class="input-group-append">
                    <button class="btn btn-outline-secondary calendar" (click)="dp4b.toggle()" type="button">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-calendar-date" viewBox="0 0 16 16">
                        <path d="M6.445 11.688V6.354h-.633A12.6 12.6 0 0 0 4.5 7.16v.695c.375-.257.969-.62 1.258-.777h.012v4.61h.675zm1.188-1.305c.047.64.594 1.406 1.703 1.406 1.258 0 2-1.066 2-2.871 0-1.934-.781-2.668-1.953-2.668-.926 0-1.797.672-1.797 1.809 0 1.16.824 1.77 1.676 1.77.746 0 1.23-.376 1.383-.79h.027c-.004 1.316-.461 2.164-1.305 2.164-.664 0-1.008-.45-1.05-.82h-.684zm2.953-2.317c0 .696-.559 1.18-1.184 1.18-.601 0-1.144-.383-1.144-1.2 0-.823.582-1.21 1.168-1.21.633 0 1.16.398 1.16 1.23z"/>
                        <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
                        </svg>
                    </button>
                    </div>
                </div>
                <br>
                <span class="bold">Fecha de Entrega</span>
                <div class="input-group">
                    <input id="fecha_entrega" class="form-control" placeholder="Fecha de entrega" [(ngModel)]="formularioEdit.fecha_entrega" value="formularioEdit.fecha_entrega" name="dp5b" ngbDatepicker #dp5b="ngbDatepicker">
                    <div class="input-group-append">
                    <button class="btn btn-outline-secondary calendar" (click)="dp5b.toggle()" type="button">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-calendar-date" viewBox="0 0 16 16">
                        <path d="M6.445 11.688V6.354h-.633A12.6 12.6 0 0 0 4.5 7.16v.695c.375-.257.969-.62 1.258-.777h.012v4.61h.675zm1.188-1.305c.047.64.594 1.406 1.703 1.406 1.258 0 2-1.066 2-2.871 0-1.934-.781-2.668-1.953-2.668-.926 0-1.797.672-1.797 1.809 0 1.16.824 1.77 1.676 1.77.746 0 1.23-.376 1.383-.79h.027c-.004 1.316-.461 2.164-1.305 2.164-.664 0-1.008-.45-1.05-.82h-.684zm2.953-2.317c0 .696-.559 1.18-1.184 1.18-.601 0-1.144-.383-1.144-1.2 0-.823.582-1.21 1.168-1.21.633 0 1.16.398 1.16 1.23z"/>
                        <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
                        </svg>
                    </button>
                    </div>
                </div>
                <br>

                

                <span class="bold">Lugar de Entrega</span>
                <input type="text" class="form-control" placeholder="Lugar de Entrega" [(ngModel)]="formularioEdit.lugar_entrega"><br>

                
    
                <span class="bold">Link de What's App</span>
                <input type="text" class="form-control" placeholder="Grupo de What's App" [(ngModel)]="formularioEdit.link_whatsapp"><br>
                
                <span class="bold">Promociones</span>
                <textarea class="form-control" placeholder="Promociones" [(ngModel)]="formularioEdit.promociones"></textarea><br>
                

                <span class="bold">Generación</span>
                <input type="text" class="form-control" placeholder="Generación" [(ngModel)]="formularioEdit.generacion"><br>
                
                <span class="bold">Estatus</span>
                <select #estatus_grupo class="form-control" [(ngModel)]="formularioEdit.estatus_grupo">
                <option value="">Seleccione Estatus</option>
                <option *ngFor="let estate of estatus" [value]="estate.id" [attr.selected]="estate.id==estatusid ? true : null">{{estate.nombre}}</option>
                </select>
                <br>
            </div>
           
            <div *ngIf="seccion == 2">

                <span class="bold">Fecha de Foto</span>
                <div class="input-group">
                    <input id="fecha_entrega" class="form-control" placeholder="Fecha de Fotografía" [(ngModel)]="formularioEdit.fecha_foto" value="formularioEdit.fecha_foto" name="dp6b" ngbDatepicker #dp6b="ngbDatepicker">
                    <div class="input-group-append">
                    <button class="btn btn-outline-secondary calendar" (click)="dp6b.toggle()" type="button">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-calendar-date" viewBox="0 0 16 16">
                        <path d="M6.445 11.688V6.354h-.633A12.6 12.6 0 0 0 4.5 7.16v.695c.375-.257.969-.62 1.258-.777h.012v4.61h.675zm1.188-1.305c.047.64.594 1.406 1.703 1.406 1.258 0 2-1.066 2-2.871 0-1.934-.781-2.668-1.953-2.668-.926 0-1.797.672-1.797 1.809 0 1.16.824 1.77 1.676 1.77.746 0 1.23-.376 1.383-.79h.027c-.004 1.316-.461 2.164-1.305 2.164-.664 0-1.008-.45-1.05-.82h-.684zm2.953-2.317c0 .696-.559 1.18-1.184 1.18-.601 0-1.144-.383-1.144-1.2 0-.823.582-1.21 1.168-1.21.633 0 1.16.398 1.16 1.23z"/>
                        <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
                        </svg>
                    </button>
                    </div>
                </div>

                <span class="bold">Hora de Foto</span>
                <ngb-timepicker [(ngModel)]="formularioEdit.hora_foto"></ngb-timepicker>
    
                <span class="bold">Lugar de Foto</span>
                <input type="text" class="form-control" placeholder="Lugar de Fotografía" [(ngModel)]="formularioEdit.lugar_foto"><br>

                <span class="bold">Link Drive Fotos</span>
                <input type="text" class="form-control" placeholder="Link Fotos Drive" [(ngModel)]="formularioEdit.link_drive"><br>
                
                <span class="bold">Fondo de Fotografía</span>
                <select #fondo class="form-control" [(ngModel)]="formularioEdit.fondo">
                <option value="">Seleccione Fondo </option>
                <option *ngFor="let fondo of fondos" [value]="fondo.id" [attr.selected]="fondo.nombre==formularioEdit.fondo ? true : null">{{fondo.nombre}}</option>
                </select>
                <br>
            </div>

            <div *ngIf="seccion == 3">
                <br>
                <div class="row">
                    <div class="col-3">
                        <br>
                        <span class="bold">Fiesta</span><br>
                        <select #fiesta class="form-control" [(ngModel)]="formularioEdit.fiesta">
                            <option value="">Seleccione Fiesta</option>
                            <option *ngFor="let fiesta of fiestas" [value]="fiesta.id">{{fiesta.nombre}}</option>   
                        </select>
                    </div>
                    <div class="col-3">
                        <span class="bold">Máximo número de boletos Adulto</span><br>
                        <input type="number" class="form-control" placeholder="Máximo de Boletos Adulto" [(ngModel)]="formularioEdit.fiesta_adulto">
                    </div>

                    <div class="col-3">
                        <span class="bold">Máximo Número de boletos de niño</span><br>
                        <input type="number" class="form-control" placeholder="Máximo de Boletos Niño" [(ngModel)]="formularioEdit.fiesta_nino">
                    </div>

                    <div class="col-3">
                        <br><br>
                        <button class="btn btn-warning" (click)="agregarFiestaGrupo()">Agregar</button>
                    </div>
                </div>
                <br><br>
                <div class="row">
                    <h3>Fiestas Seleccionadas</h3>
                    <br>
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th scope="col">Fiesta</th>
                                <th scope="col">Boletos Máximos Adulto</th>
                                <th scope="col">Boletos Máximos Niño</th>
                                <th scope="col">Eliminar</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let fiestaG of fiestasGrupo">
                                <td>{{fiestaG.nombre_fiesta}}</td>
                                <td>{{fiestaG.maximo_boletos}}</td>
                                <td>{{fiestaG.maximo_boletos_nino}}</td>
                                <td><button class="btn btn-danger" (click)="eliminarFiestaGrupo(fiestaG.id)">Eliminar</button></td>
                            </tr>
                        </tbody>
                    </table>
                </div>


                <br><br>
                <div class="row">
                    <div class="col-3">
                        <br>
                        <span class="bold">Viaje</span><br>
                        <select #fiesta class="form-control" [(ngModel)]="formularioEdit.viaje">
                            <option value="">Seleccione Viaje</option>
                            <option *ngFor="let viaje of viajes" [value]="viaje.id">{{viaje.nombre}}</option>   
                        </select>
                    </div>
                    <div class="col-3">
                        <span class="bold">Númeroo máximo de lugares</span><br>
                        <input type="number" class="form-control" placeholder="Máximo de Lugares" [(ngModel)]="formularioEdit.numero_maximo_lugares">
                    </div>

                    <div class="col-3">
                    </div>

                    <div class="col-3">
                        <br><br>
                        <button class="btn btn-warning" (click)="agregarViajeGrupo()">Agregar</button>
                    </div>
                </div>
                <br><br>
                <div class="row">
                    <h3>Viajes Seleccionados</h3>
                    <br>
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th scope="col">Viaje</th>
                                <th scope="col">Número máximo de lugares</th>
                                <th scope="col">Eliminar</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let viajeG of viajesGrupo">
                                <td>{{viajeG.nombre_viaje}}</td>
                                <td>{{viajeG.numero_maximo_lugares}}</td>
                                <td><button class="btn btn-danger" (click)="eliminarViajeGrupo(viajeG.id)">Eliminar</button></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
                
            <!-- <span class="bold">Categoría</span> -->
            <!-- <select class="form-control" [(ngModel)]="formularioEdit.categoria">
                <option value="">Seleccione Categoría</option>
                <option *ngFor="let categoriaE of categorias" [value]="categoriaE.id">{{categoriaE.nombre}}</option>
            </select><br><br> -->
          
            <div *ngIf="seccion == 4">
                <span class="bold">Vendedor</span>
                <select class="form-control" [(ngModel)]="formularioEdit.vendedor">
                    <option value="">Seleccione Vendedor</option>
                    <option *ngFor="let vendedor of vendedores" [value]="vendedor.id">{{vendedor.nombre}}</option>
                  </select><br>

                <span class="bold">Color de Estola</span>
                <select #estola class="form-control" [(ngModel)]="formularioEdit.estola">
                <option value="">Seleccione Color</option>
                <option *ngFor="let estola of estolas" [value]="estola.id" [attr.selected]="estola.nombre==formularioEdit.estola ? true : null">{{estola.nombre}}</option>
                </select>
                <br>
                
                <span class="bold">Sesión Temática</span>
                <select #tematica class="form-control" [(ngModel)]="formularioEdit.sesion_tematica">
                <option value="">Seleccione Sesión Temática</option>
                <option *ngFor="let sesion of sesiones" [value]="sesion.id" [attr.selected]="sesion.id==sesion_tematicaid ? true : null">{{sesion.nombre}}</option>
                </select>

                <img src="{{enviroment}}{{datosGrupo.escudo}}" width="200px">
                Imagen:<br>
                <input (change)="imageChange($event.target.files)" type="file"accept="image/*" id="imagen"><br><br>
                
                <img src="{{enviroment}}{{datosGrupo.escudo2}}" width="200px">
                Imagen 2:<br>
                <input (change)="imageChange2($event.target.files)" type="file"accept="image/*" id="imagen2"><br><br>
            </div>
            
            
            
            <button type="button" class="btn btn-warning" (click)="updateGrupo(grupoId)">Actualizar</button>
            {{error}}
            <br><br><br>
        </div>  
    </div>
</div>







<!-- <input type="text" class="form-control" placeholder="Hora de Foto hh:mm" [(ngModel)]="formularioEdit.hora_foto"><br> -->




      
